import { Col, FormFeedback, FormGroup, Row } from "reactstrap"
import { LabelText } from "../Utils/Input"
import InputField from "../Utils/InputField"
import SelectField from "../Utils/SelectField"

export const SubscriptionDetails = ({ values, touched, errors, handleChange, setFieldValue, idArray, subscriptionId, id }) => {
    return (
        <>
            <Col lg={3} md={4} sm={12} className='mb-3'>
                <FormGroup>
                    <LabelText htmlFor={'subscriptionID'} className={'text-danger'} classLabelName={
                        "ms-0 rv-form-label"
                    } displayText={'Subscription ID'} important={!id && '*'} />
                    <LabelText
                        htmlFor={"subscriptionID"}
                        classLabelName={`d-block ms-0 rv-sub-label ${touched.subscriptionID && errors.subscriptionID
                            ? "rv-label-danger"
                            : "rv-label-muted"
                            } `}
                        displayText={
                            touched.subscriptionId &&
                                errors.subscriptionId
                                ? errors.subscriptionId
                                : `Enter Subscription ID`
                        }
                    />
                    <InputField
                        name={"subscriptionID"}
                        placeholder={" "}
                        type={"text"}
                        className={"form-control"}
                        id={"subscriptionID"}
                        value={subscriptionId ? subscriptionId : values.subscriptionID}
                        disabled={subscriptionId}
                        invalid={touched.subscriptionID && errors.subscriptionID ? true : false}
                        handleChange={handleChange}
                    />
                    {/* {touched.subscriptionID && errors.subscriptionID ? (
                        <FormFeedback type="invalid">{errors.subscriptionID}</FormFeedback>
                    ) : null} */}
                </FormGroup>
            </Col>
            <Col lg={3} md={4} sm={12} className='mb-3'>
                <FormGroup>
                    <LabelText htmlFor={'selectDevice'} displayText={'Select Device'} />
                    <LabelText
                        htmlFor={"selectDevice"}
                        classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                        displayText={
                            "Select A Device"
                        }
                    />
                    <SelectField
                        name={"selectDevice"}
                        isClearable={true}
                        handleChange={(selectedDevice) => setFieldValue('selectDevice', selectedDevice)}
                        options={idArray}
                        placeholder=""
                        isRVStyle={true}
                        value={values.selectDevice}
                    />
                </FormGroup>
            </Col>
        </>
    )
}